"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
require("./style.scss");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _default(ComposedClass) {
  var AutoTimeout = /*#__PURE__*/function (_React$Component) {
    function AutoTimeout(props) {
      var _this;
      _classCallCheck(this, AutoTimeout);
      _this = _callSuper(this, AutoTimeout, [props]);
      _this.state = {
        warningTime: 1000 * 60 * 19,
        //process.env.TIMEOUT_WARNING_MINUTES,
        signoutTime: 1000 * 60 * 20,
        //process.env.TIMEOUT_MINUTES,
        showWarning: false,
        extensionCount: 0,
        time: {},
        seconds: 5
      };
      _this.timer = 0;
      _this.clearTimeoutFunc = _this.clearTimeoutFunc.bind(_this);
      _this.setTimeout = _this.setTimeout.bind(_this);
      _this.resetTimeout = _this.resetTimeout.bind(_this);
      _this.onClick = _this.onClick.bind(_this);
      _this.logout = _this.logout.bind(_this);
      _this.destroy = _this.destroy.bind(_this);
      return _this;
    }
    _inherits(AutoTimeout, _React$Component);
    return _createClass(AutoTimeout, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.events = ['load', 'mousemove', 'mousedown', 'click', 'scroll', 'keypress'];
        for (var i in this.events) {
          window.addEventListener(this.events[i], this.resetTimeout.bind(this));
        }
        this.setTimeout();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearTimeoutFunc();
      }
    }, {
      key: "secondsToTime",
      value: function secondsToTime(secs) {
        var hours = Math.floor(secs / (60 * 60));
        var divisor_for_minutes = secs % (60 * 60);
        var minutes = Math.floor(divisor_for_minutes / 60);
        var divisor_for_seconds = divisor_for_minutes % 60;
        var seconds = Math.ceil(divisor_for_seconds);
        var obj = {
          "h": hours,
          "m": minutes,
          "s": seconds
        };
        return obj;
      }
    }, {
      key: "clearTimeoutFunc",
      value: function clearTimeoutFunc() {
        if (this.warnTimeout) {
          clearTimeout(this.warnTimeout);
          this.warnTimeout = 0;
        }
        if (this.logoutTimeout) {
          clearTimeout(this.logoutTimeout);
          this.logoutTimeout = 0;
        }
      }
    }, {
      key: "setTimeout",
      value: function (_setTimeout) {
        function setTimeout() {
          return _setTimeout.apply(this, arguments);
        }
        setTimeout.toString = function () {
          return _setTimeout.toString();
        };
        return setTimeout;
      }(function () {
        this.warnTimeout = setTimeout(this.warn.bind(this), this.state.warningTime);
        this.logoutTimeout = setTimeout(this.logout.bind(this), this.state.signoutTime);
      })
    }, {
      key: "resetTimeout",
      value: function resetTimeout() {
        if (!this.state.showWarning) {
          this.clearTimeoutFunc();
          this.setTimeout();
        }
      }
    }, {
      key: "warn",
      value: function warn() {
        if (this.state.extensionCount < 3) {
          //process.env.TIMEOUT_EXTENSION_COUNT_ALLOWED){
          this.setState({
            extensionCount: this.state.extensionCount + 1,
            showWarning: true,
            seconds: 60 //process.env.TIMEOUT_MINUTES - process.env.TIMEOUT_WARNING_MINUTES
          });
          if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown.bind(this), 1000);
          }
        }
      }
    }, {
      key: "countDown",
      value: function countDown() {
        // Remove one second, set state so a re-render happens.
        var seconds = this.state.seconds - 1;
        this.setState({
          time: this.secondsToTime(seconds),
          seconds: seconds
        });

        // Check if we're at zero.
        if (seconds === 0) {
          clearInterval(this.timer);
          this.timer = 0;
          this.logout();
        }
      }
    }, {
      key: "logout",
      value: function logout() {
        this.clearTimeoutFunc();
        this.destroy();
      }
    }, {
      key: "onClick",
      value: function onClick() {
        this.resetTimeout();
        this.setState({
          showWarning: false
        });
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.onClick();
        this.props.history.replace('/timeout');
        location.reload();
      }
    }, {
      key: "render",
      value: function render() {
        var showHideClassName = this.state.showWarning ? "modal display-block" : "modal display-none";
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ComposedClass, this.props), /*#__PURE__*/React.createElement("div", {
          className: "view-container-medium align-center"
        }, /*#__PURE__*/React.createElement("div", {
          className: showHideClassName
        }, /*#__PURE__*/React.createElement("section", {
          className: "modal-main"
        }, /*#__PURE__*/React.createElement("h1", {
          className: "tds-h1--small"
        }, "Warning"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
          className: "spacing"
        }, /*#__PURE__*/React.createElement("p", null, "You will be logged out automatically in ", /*#__PURE__*/React.createElement("b", null, " ", this.state.time.m, " : ", this.state.time.s, " "), ". Click Ok to extend the session."), /*#__PURE__*/React.createElement("div", {
          className: "modal-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: " tds-button--tertiary buttonwidth",
          onClick: this.onClick
        }, "Ok"), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "tds-button--tertiary buttonwidth",
          onClick: this.logout
        }, "Cancel")))))));
      }
    }]);
  }(React.Component);
  return AutoTimeout;
}